module.exports = __webpack_public_path__ + "img/tuxsuite.a97a02df.svg";